import React from 'react';
import { ScreenProps } from '@fnol/library/src/lib';
import { Button } from '@fnol/library/src/components';
import Box from '@mui/material/Box';
import { translations } from '../../lib/consts';
import { Typography } from '@mui/material';
import { common } from '@fnol/library/src/lib/consts';

export const SecondMessage = ({ navigator }: ScreenProps) => {
    const [currentStep, { goForward, goBack }] = navigator;
    return (
        <>
            <Box sx={{ width: '100%', height: 400, paddingTop: '15px', overflowY: 'scroll' }}>
                <Typography>
                    <div style={{ textAlign: 'center' }}>
                        <h2>{translations.intro.INTRO_MESSAGE_2_TITLE}</h2>
                    </div>
                    <div style={{ fontSize: '1.1rem' }}>{translations.intro.INTRO_MESSAGE_2_TEXT_1}</div>
                    <div style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                        {translations.intro.INTRO_MESSAGE_2_TEXT_2}
                    </div>
                    <h3>{translations.intro.INTRO_MESSAGE_2_SUBTITLE_1}</h3>
                    <ul style={{ fontSize: '1.1rem' }}>
                        <li>{translations.intro.INTRO_MESSAGE_2_LINE_1_1}</li>
                        <li>{translations.intro.INTRO_MESSAGE_2_LINE_1_2}</li>
                    </ul>
                    <h3>{translations.intro.INTRO_MESSAGE_2_SUBTITLE_2}</h3>
                    <ul style={{ fontSize: '1.1rem' }}>
                        <li>{translations.intro.INTRO_MESSAGE_2_LINE_2_1}</li>
                        <li>{translations.intro.INTRO_MESSAGE_2_LINE_2_2}</li>
                    </ul>
                    <h3>{translations.intro.INTRO_MESSAGE_2_SUBTITLE_3}</h3>
                    <ul style={{ fontSize: '1.1rem' }}>
                        <li>{translations.intro.INTRO_MESSAGE_2_LINE_3}</li>
                    </ul>
                    <h3>{translations.intro.INTRO_MESSAGE_2_SUBTITLE_4}</h3>
                    <ul style={{ fontSize: '1.1rem' }}>
                        <li>{translations.intro.INTRO_MESSAGE_2_LINE_4_1}</li>
                        <li>{translations.intro.INTRO_MESSAGE_2_LINE_4_2}</li>
                        <li>{translations.intro.INTRO_MESSAGE_2_LINE_4_3}</li>
                        <li>{translations.intro.INTRO_MESSAGE_2_LINE_4_4}</li>
                        <li>{translations.intro.INTRO_MESSAGE_2_LINE_4_5}</li>
                    </ul>
                    <h3>{translations.intro.INTRO_MESSAGE_2_SUBTITLE_5}</h3>
                    <ul style={{ fontSize: '1.1rem' }}>
                        <li>{translations.intro.INTRO_MESSAGE_2_LINE_5_1}</li>
                        <li>{translations.intro.INTRO_MESSAGE_2_LINE_5_2}</li>
                    </ul>
                    <h3>{translations.intro.INTRO_MESSAGE_2_SUBTITLE_6}</h3>
                    <ul style={{ fontSize: '1.1rem' }}>
                        <li>
                            {translations.intro.INTRO_MESSAGE_2_LINE_6_1}
                            <b>{translations.intro.INTRO_MESSAGE_2_LINE_6_2}</b>
                        </li>
                        <li>{translations.intro.INTRO_MESSAGE_2_LINE_6_3}</li>
                    </ul>
                </Typography>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    paddingTop: '15px',
                }}
            >
                <Button onClickHandler={goBack} label={common.PREVIOUS} />
                <Button onClickHandler={goForward} label={common.NEXT} />
            </Box>
        </>
    );
};
